import { CircularProgress, Stack, Typography } from "@mui/material";
import { ColorScheme } from "../../Themes/ColorScheme";

export const Spinner = ({ small, hasText, hasColor, color, size }) => (
	<Stack
		alignItems="center"
		justifyContent="center"
		spacing={4}
		direction="row"
	>
		<CircularProgress
			size={size || (small && "25px")}
			color={small ? "info" : "secondary"}
			style={{ color: color && color }}
		/>
		{hasText && (
			<Typography fontSize={"12px"} color={hasColor || ColorScheme.secondary}>
				{hasText}
			</Typography>
		)}
	</Stack>
);
